const parseCache = new Map<string, string>();

/**
 * This is an expensive operation, so we cache the results.
 * TODO: Overtime, within the same session, the cache will grow,
 * so we should consider clearing it out based on some criteria.
 * Currently it's not something that is causing any issues but
 * theoretically it could.
 * @param html
 * @returns
 */
export const HTMLToText = (html: string) => {
  if (parseCache.has(html)) {
    return parseCache.get(html) ?? "";
  }
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  // Remove all new lines and trim the text. The current issue is only coming due to new lines (what ve observed) if see any other cases the below regex or new conditions will be added.
  const sanitizedValue = doc?.body?.textContent?.replace(/\s+/g, " ").trim();
  parseCache.set(html, sanitizedValue ?? "");
  return sanitizedValue ?? "";
};

export const ellipsisText = (
  text: string,
  options: { maxWidth?: number; nodeWidth?: number }
) => {
  const { maxWidth = 0, nodeWidth = 0 } = options;

  if (!maxWidth || nodeWidth <= maxWidth) {
    return text;
  }

  const sliceLength = Math.floor(text.length * (maxWidth / nodeWidth));

  const newText = text.substring(0, sliceLength - 1).trimEnd() + "…"; // using actual unicode ellipsis character

  return newText;
};
